import { render, staticRenderFns } from "./WireCalculator.vue?vue&type=template&id=37b34de3&scoped=true"
import script from "./WireCalculator.vue?vue&type=script&lang=js"
export * from "./WireCalculator.vue?vue&type=script&lang=js"
import style0 from "./WireCalculator.vue?vue&type=style&index=0&id=37b34de3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b34de3",
  null
  
)

export default component.exports